import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PreparationModifierSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "metaTagDefinitionId";
    }

    override getResourceName(): string {
        return "meta-tag-definition";
    }

    override getResource(): string {
        return "preparation-modifier";
    }
}
